<template>
    <transition name="modal">
        <div class="modal__mask modalParticipanteFundo" v-if="showModalCreate">
            <div class="modal__wrapper">
                <div class="modal__container reset">
                    <div class="content__modal">
                        <a @click.stop.prevent="closeModal" class="close__modal">x</a>
                        <div class="inner__modal">
                            <div style="display: inline-flex; width: 300px;">
                                <img style="width: 50px; height: 50px;" src="@/assets/addRepresentante.png" />
                                <h2 style="margin-top: -35px;">Adicionar participante</h2>
                            </div>
                            <form action="" class="form__class" @submit.stop.prevent="createRepresentante">
                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label">Selecione tipo*</label>
                                        <select class="field" v-model="representante.Tipo">
                                            <option value="">Selecione</option>
                                            <option value="Diretor">Diretor</option>
                                            <option value="Administrador">Administrador</option>
                                        </select>
                                        <p v-if="camposObrigatorios.erroTipo" class="erro">Campo obrigatório.</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls">

                                        <InputNome 
                                            v-model="representante.Nome"
                                            label="Nome"
                                            :required="true"
                                            :erro="camposObrigatorios.erroNome"
                                        /> 

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label">CPF/CNPJ*</label>
                                        <input type="text" class="field" autocomplete="off" @click.stop.prevent="clear"
                                            v-model="representante.CpfCnpj" />
                                        <p v-if="camposObrigatorios.erroCpfCnpj" class="erro">Campo obrigatório.</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label">E-mail</label>
                                        <input type="text" class="field" autocomplete="off" @click.stop.prevent="clear"
                                            v-model="representante.Email" @blur="validarEmail" />
                                        <p v-if="emailErros.email" class="erro">{{ emailErros.email }}</p>

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls">
                                        <telefone-internacional 
                                            v-model="representante.Telefone" 
                                            label="Telefone" 
                                            :name="'Telefone'"
                                            :opcional="true"
                                            @validate="onValidateTelefone"
                                        />

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label">Cargo</label>
                                        <input type="text" class="field" autocomplete="off"
                                            v-model="representante.Cargo" @click.stop.prevent="clear"
                                            :class="{ erro: erroName }" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label">Assinatura*</label>
                                        <select id="assinante" class="field" v-model="representante.Assinatura">
                                            <option value=""></option>
                                            <option value="1">Não assina pela empresa</option>
                                            <option value="2">Assina isoladamente</option>
                                            <option value="0">Assina em conjunto</option>
                                        </select>
                                        <p v-if="camposObrigatorios.erroAssinatura" class="erro">Campo obrigatório.</p>
                                    </div>
                                </div>
                                <div class="buttonsAcoes">
                                    <button class="btnDefault" type="button" :disabled="disableBtn"
                                        @click="closeModal">Cancelar</button>
                                    <button v-if="representante.Guid == ''" class="btnBlue" type="button"
                                        @click="salvarRepresentante">Adicionar</button>
                                    <button v-if="representante.Guid != ''" class="btnBlue" type="button"
                                        @click="salvarRepresentante">Atualizar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import emailValidatorMixin from '@/utils/emailValidatorMixin.js';
import { mapGetters } from "vuex";
import api from '@/api/axios';

import { confirmarReassinatura } from "@/utils/confirmarReassinatura";
import { verificarDocumentoAtivo } from "@/utils/verificarDocumentoAtivo";

export default {
    computed: {
        ...mapGetters({
            showModalCreate: "GET_MODAL_FI_ADD_PARTICIPANTE",
            editarRepresentante: 'GET_MODAL_FI_EDITAR_PARTICIPANTE',
            user: 'auth/user',
        }),
    },
        mixins: [emailValidatorMixin],
    data() {
        return {
            emailErros: {},
            telefoneValido: [],
            permitirAvancar: false,
            camposObrigatorios: {
                erroTipo: false,
                erroNome: false,
                erroCpfCnpj: false,
                erroAssinatura: false
            },
            representante: {
                Guid: '',
                Nome: '',
                Email: '',
                Telefone: '',
                Cargo: '',
                CpfCnpj: '',
                Tipo: '',
                Assinatura: ''
            }
        }
    },
    watch: {
        editarRepresentante() {
            if (this.editarRepresentante != null) {
                this.representante = this.editarRepresentante;
                this.validarEmail();
            } else {
                this.limparObj();
            }
        }
    },
    methods: {
        validarEmail() {
            this.validarEmailGeneric(this.representante.Email, 'email', {
                obrigatorio: false,
            });
        },
        onValidateTelefone({ name, valid }) {
            if (!this.telefoneValido) {
                this.telefoneValido = {};
            }
            if(valid != 'undefined'){
                this.telefoneValido[name] = valid;
            }
        },
        closeModal() {
            this.camposObrigatorios.erroTipo = false;
            this.camposObrigatorios.erroNome = false;
            this.camposObrigatorios.erroCpfCnpj = false;
            this.camposObrigatorios.erroAssinatura = false;
            this.$store.commit("SET_MODAL_FI_ADD_PARTICIPANTE", false);
            this.$store.commit("SET_MODAL_FI_EDITAR_PARTICIPANTE", null);
        },
        limparObj() {
            this.representante = {
                Guid: '', // valor padrão
                Nome: '', // valor padrão
                Email: '', // valor padrão
                Telefone: '',
                Cargo: '',
                CpfCnpj: '', // valor padrão
                Tipo: '', // valor padrão
                Assinatura: ''
            };
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            var valorInvalido = false;
            this.camposObrigatorios = {
                erroTipo: false,
                erroNome: false,
                erroCpfCnpj: false,
                erroAssinatura: false
            };
            if (this.representante.Tipo === null || this.representante.Tipo === undefined || this.representante.Tipo === '') {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroTipo = true;
                    nomeDoCampo = 'Tipo';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Nome) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroNome = true;
                    nomeDoCampo = 'Nome';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.CpfCnpj) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroCpfCnpj = true;
                    nomeDoCampo = 'CPF/CNPJ';
                }
                this.permitirAvancar = false;
            }

                const telefoneValido = this.telefoneValido[`Telefone`];


                    if (this.representante.Telefone.length > 4 && (!this.representante.Telefone || telefoneValido == false)) {
                    if (submeter && this.permitirAvancar) {
                        nomeDoCampo = 'Telefone';
                    }
                        if(telefoneValido== false){
                            valorInvalido = true;
                        }
                        this.permitirAvancar = false;
                    }


            if (this.representante.Assinatura === null || this.representante.Assinatura === undefined || this.representante.Assinatura === '') {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroAssinatura = true;
                    nomeDoCampo = 'Assinatura';
                }
                this.permitirAvancar = false;
            }
             if (Object.values(this.emailErros).some(erro => erro !== '')) {
                if (submeter && this.permitirAvancar) {
                    nomeDoCampo = 'E-mail';
                }
                this.permitirAvancar = false;
            }
            if (submeter && nomeDoCampo != '') {

                if(valorInvalido){

                    this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo ` + nomeDoCampo + ` foi informado, mas não foi preenchido corretamente. Preencha a informação para avançar.`,
                });

                }else{

                    this.$swal({
                        icon: 'warning',
                        title: 'Oops...',
                        text: `O campo ` + nomeDoCampo + ` não foi informado ou é inválido, preencha a informação para avançar.`,
                    });
                }
            }
        },
        async salvarRepresentante() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                this.disableBtn = true;

                if((this.representante.Guid == '' && String(this.representante.Assinatura) != '1') || 
                    this.representante.Guid != '')
                {
                    var documentoAtivo = await verificarDocumentoAtivo();

                    if (documentoAtivo) {
                        var confirmado = await confirmarReassinatura();
                        if (!confirmado){ 
                            return;
                        }
                    }
                }
                 
                await api
                    .post('/Fundo/emissorOrdem', this.representante)
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            this.$swal({
                                icon: 'success',
                                title: this.representante.Guid == '' ? 'Inclusão realizada com sucesso!' : 'Alteração realizada com sucesso!',
                                text: 'Dados informados foram salvos com sucesso.',
                            });
                            this.limparObj();
                            this.$store.commit("SET_MODAL_FI_ADD_PARTICIPANTE", false);
                            this.$store.dispatch('FETCH_FI_INFO_PARTICIPANTE_CUSTODIANTE');
                        }
                    })
                    .catch((error) => {
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            }
        }
    },
};
</script>

<!--<style lang="scss">
@include modal;
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');
.subTitle {
    color: #383333;
    ;
    margin-top: -30px;
    margin-bottom: 30px;
    font-size: large;
    font-family: "Work Sans", sans-serif;
    font-weight: 400 !important;
}
.modalParticipanteFundo .modal__wrapper .modal__container.reset {
    width: 400px !important;
    height: 650px !important;
}
.titleConta {
    font-weight: 800 !important;
    text-transform: uppercase;
}
.btnLogin {
    background-color: #565656 !important;
}
.subTitleCinza {
    width: 52%;
    text-align: center;
    font-weight: 400 !important;
    color: #707070 !important;
    font-family: "Work Sans", sans-serif;
}
.content__modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    .close__modal {
        position: absolute;
        right: 34px;
        top: 30px;
        font-family: "Montserrat";
        @media (max-width: 768px) {
            top: 16px;
            right: 16px;
        }
    }
    h3 {
        margin-bottom: 46px;
        @media (max-width: 768px) {
            font-size: 24px;
            margin-bottom: 20px;
            text-align: center;
            max-width: 280px;
        }
    }
}
</style>-->